<ng-container *ngIf="isMobile; else desktopLayout">
  <section class="editorial-link-list-mobile" [appStoryblokEditable]="editorialList._editable">
    <h2 class="editorial-link-list-mobile__title">{{ editorialList.title }}</h2>
    <div>
      <ul class="editorial-link-list-mobile__link-list">
        <li *ngFor="let link of editorialList.listLink">
          <app-mobile-menu-item
            [linkText]="link.linkText"
            [link]="link.link"
            (onClick)="onLinkClick(link.link)"
            [appStoryblokEditable]="link._editable"
          >
          </app-mobile-menu-item>
        </li>
      </ul>
    </div>
  </section>
</ng-container>

<ng-template #desktopLayout>
  <section class="editorial-link-list-desktop" [appStoryblokEditable]="editorialList._editable">
    <h2 class="editorial-link-list-desktop__title">
      {{ editorialList.title }}
    </h2>
    <ul class="editorial-link-list-desktop__link-list">
      <li *ngFor="let link of editorialList.listLink; let i = index" [appStoryblokEditable]="link._editable">
        <a
          class="editorial-link-list-desktop__link-list__item"
          fxLayout="column"
          (click)="onNavigate(link.link); onLinkClick()"
          appDisableClickEvent
          >{{ link.linkText }}</a
        >
      </li>
    </ul>
  </section>
</ng-template>
